module.exports = __webpack_public_path__ + "img/157.252c3f92.jpg";